import { render, staticRenderFns } from "./PageCardDropHelper.vue?vue&type=template&id=2265a3f9&"
import script from "./PageCardDropHelper.vue?vue&type=script&lang=js&"
export * from "./PageCardDropHelper.vue?vue&type=script&lang=js&"
import style0 from "./PageCardDropHelper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports